import { isProd } from "./components/helpers/misc";

const PROD_DATABASE_URL = "https://capital-clues-default-rtdb.firebaseio.com";
const QA_DATABASE_URL = "https://capital-clues-qa.firebaseio.com"; // Replace with your QA instance URL from Firebase Console

const firebaseConfig = {
  apiKey: "AIzaSyAwEJaSmtUT6q89RqXe3DA1sxRPlgUaMv4",
  authDomain: "capital-clues.firebaseapp.com",
  databaseURL: isProd ? PROD_DATABASE_URL : QA_DATABASE_URL,
  projectId: "capital-clues",
  storageBucket: "capital-clues.appspot.com",
  messagingSenderId: "1007538950403",
  appId: "1:1007538950403:web:6c599c857d5a512498d936",
};

export default firebaseConfig;
export { PROD_DATABASE_URL, QA_DATABASE_URL };